import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Container } from "reactstrap";

// core components
import { Col, Row } from "stories/layout"
import { useNotification } from "stories/components/Notification"

// Import the new form component
import RegisterPrivateAndBusinessForm from "components/Forms/RegisterForm/RegisterPrivateAndBusinessForm";

const RegisterView = ({location, match, history}) => {
  const { t } = useTranslation();
  const { notify } = useNotification();
  
  const handleModalConfirm = () => {
    // history.push("/dashboard/users");
  }
  
  const handleResolve = () => {
    notify({ title:t("Käyttäjä"), message:t("Uusi käyttäjä luotu onnistuneesti")})
    handleModalConfirm();
  }
  
  return (
    <>
      <Container className="mt-4 pb-5">
        <Row className="justify-content-center">
          <Col lg="6" md="7" className="">
            <RegisterPrivateAndBusinessForm 
              history={history} 
              t={t} 
              handleResolve={handleResolve} 
              notify={notify} 
            />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default RegisterView;
